import React, { SFC } from "react";
import Container from "@material-ui/core/Container";
import {Box, Card, Grid, useMediaQuery, useTheme} from "@material-ui/core";
import PreferencesForm from "../../Components/PreferencesForm";
import Navigation from "../../Components/Navigation";

interface Props {
	isOnBoarding: boolean,
	setIsOnBoarding: React.Dispatch<React.SetStateAction<boolean>>,
}
const PartnerPreferences = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    return (
        <Container maxWidth="md">
            <Box marginTop="115px" marginBottom="75px">
                <Grid container>
                    {!isMobile &&
						<Grid item md={3} xs={12}>
						    <Navigation /> 
						</Grid>
                    }
                    <Grid item md={9} xs={12}>
                        <PreferencesForm/>
                    </Grid>
                </Grid>
            </Box>
        </Container>
    );
};

export default PartnerPreferences;
